import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Paginate from 'vuejs-paginate'
import PageTracker from '../../../../common/PageTrackerHelper'
import moment from 'moment';
import Papa from "papaparse";
// import CProgress from '@coreui/vue/src/components/progress/CProgress'

export default {
  name: 'lostReports',
  components: {
      VueElementLoading,
      Paginate,
      // CProgressBar
  },
  mixins:[PageTracker],
  data: function() {
      return {
        file: '',
        filename: '',
        filedata: [],
        PromiseChainResult: [],
        isLoading: false,
        isDownloadFlag: false,
        UpdateApprovalKey: [],
        approvalfor: 0,
        uploadResult: [],
        errorList: [],
        batchkeyArray: [],
        UploadConfigDetails: {},
        uploadLimit : 0
      }
  },
  created: function() {
  },
async mounted(){
    let validateUser = await this.validateJwtToken();
    // console.log('test -->>', currentDate.format('M'););
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;

    // let TrackerInfo = {
    //     projectname:"Lastmile-web",
    //     type:"Web",
    //     userid:this.localuserid,
    //     username:this.localusermailid,
    //     meta: {
    //         "event":""
    //     }
    // }
    // let result  = this.PageTracker(TrackerInfo);
    let getconfig = await this.getconfigFlags()
    this.UploadConfigDetails = JSON.parse(getconfig);
    this.uploadLimit = this.UploadConfigDetails.pageCuttoff
    console.log('this.UploadConfigDetails ----->>', this.UploadConfigDetails);
    //console.log('Mixin is working for :',result);
  },
  methods : {
    async chooseFile(e){
       try {
       const files = e.target.files;
       this.filename = e.target.files[0].name;
       this.file = e.target.files[0];
       // console.log('file names ', this.file);
       await this.parseFile();
       // console.log('this.filedata --->>>', this.filedata.data);
       } catch(err){
         console.log(err);
       }
    },
    async parseFile(){
       var count = 0; // cache the running count
       var csvData=[];
       var sheetid = 1;
       var validheader = 1;
       var sheetApproveKey = 'appoveDataKey1'
       var holdErrors = []
       var vm = this
       Papa.parse( this.file, {
           header: true,
           skipEmptyLines: true,
           before: this.isLoading = true,
           worker: true, // Don't bog down the main thread if its a big file
           step: async function(result) {
             // console.log("result -------->>>>", result);
             let fileHeaders = result.meta.fields;
             // let fileHeaders = result.meta.fields.map(word => word.toLowerCase());
             // console.log('fileHeaders ---------->', fileHeaders);
             if(sheetid==1 && !fileHeaders.includes("SHIPPINGID") ||
               !fileHeaders.includes(("DEBITFROMTYPE")) ||
               !fileHeaders.includes("DEBITID")){
                 this.filedata = [];
                 this.filename=null;
                 validheader = 0;
             }
             sheetid ++;
             let tempResult = {};
               tempResult.shippingid = (result.data['SHIPPINGID'])?result.data['SHIPPINGID']:null;
               tempResult.debitfromtype = (result.data['DEBITFROMTYPE'])?result.data['DEBITFROMTYPE']:null;
               tempResult.userid = (result.data['DEBITID'])?result.data['DEBITID']:null;
               // tempResult.debitamount = (result.data['debitamount'])?result.data['debitamount']:null;
               // tempResult.remainingamount = (result.data['remainingamount'])?result.data['remainingamount']:null;
               // tempResult.status = (result.data['status'])?result.data['status']:null;
               // tempResult.ispartialdebit = (result.data['ispartialdebit'])?result.data['ispartialdebit']:null;
               // tempResult.comments = (result.data['comments'])?result.data['comments']:null;
               // tempResult.CreatedBy = 'schedular'
               // tempResult.approvalkey = sheetApproveKey

               // let shippingIDvalidation = await vm.validteShippingID(holdErrors,tempResult,sheetid)
               // let debitFromTypeValidation = await vm.validteDebitFromType(holdErrors,tempResult,sheetid)
               // let debituservalidation = await vm.validteUserid(holdErrors,tempResult,sheetid)
               // let debitamountvalidation = vm.validteDebitAmount(holdErrors,tempResult,sheetid)
               // let remainingAmountValidation = await vm.validteRemainingAmount(holdErrors,tempResult,sheetid)
               // let ispartialValidation = await vm.validteIspartial(holdErrors,tempResult,sheetid)
               // console.log('debitamountvalidation --->>', debitamountvalidation);

               //csv row validations.
               if(tempResult.shippingid == null) {
                 holdErrors.push({'lineNumber': sheetid, 'message': 'Shipping id should not be empty.!'})
               }

               if(tempResult.debitfromtype == null ) {
                 holdErrors.push({'lineNumber': sheetid, 'message': 'DebitFromType column should not be empty.!'})
               }
               if(tempResult.userid == null) {
                 holdErrors.push({'lineNumber': sheetid, 'message': 'Debit user id column should not be empty.!'})
               }

               let numberRegex = /^[0-9]+$/;
               let alphaNUmeric = /^[a-z0-9]+$/i;

               if(tempResult.shippingid != null && alphaNUmeric.test(tempResult.shippingid) == false) {
                 holdErrors.push({'lineNumber': sheetid, 'message': 'Invalid shippingid, Please provide valid shipping id and it must be alphanumeric.!'})
               }
               if(tempResult.userid != null && numberRegex.test(tempResult.userid) == false) {
                 holdErrors.push({'lineNumber': sheetid, 'message': 'Debit user id must be be number.!'})
               }
               if(tempResult.debitfromtype != null && !['servicecenter','coloader','courier','networkvendor','vendor'].includes(tempResult.debitfromtype.toLowerCase().trim())) {
                 holdErrors.push({'lineNumber': sheetid, 'message': 'Invalid debit from type, Please provide valid debitfromtype.!'});
               }
               // console.log('tempResult.debitid ---->>', tempResult.userid);

               // let numberDebitRegex = /^\d*\.?\d*$/;
               // // if(tempResult.debitamount == null) {
               // //   holdErrors.push({'lineNumber': sheetid, 'message': 'Debit amount  not be empty.!'})
               // // }
               // // if(tempResult.debitamount == 0) {
               // //   holdErrors.push({'lineNumber': sheetid, 'message': 'Debit amount must be greater than zero.!'})
               // // }
               // if(numberDebitRegex.test(parseFloat(tempResult.debitid)) == false) {
               //   holdErrors.push({'lineNumber': sheetid, 'message': 'Debit user id should be number.!'})
               // }
               // //
               // // if(tempResult.remainingamount == null) {
               // //   holdErrors.push({'lineNumber': sheetid, 'message': 'Remaining amount should not be empty.!'})
               // // }
               // // if(numberDebitRegex.test(parseFloat(tempResult.remainingamount)) == false) {
               // //   holdErrors.push({'lineNumber': sheetid, 'message': 'Remaining amount should be number.!'})
               // // }
               //
               // if(tempResult.ispartialdebit == null) {
               //   pushErrors.push({'lineNumber': sheetid, 'message': 'Partial debit column should not be empty.!'})
               // }
               // if(!['0','1'].includes(tempResult.ispartialdebit)) {
               //   holdErrors.push({'lineNumber': sheetid, 'message': 'Partial column allows only input as 0 or 1.!'})
               // }

               if(tempResult.shippingid != null && tempResult.userid != null && tempResult.debitfromtype != null) {
                  // console.log('success');
                  csvData.push(tempResult);
               }
               // console.log("csvData ----------->>", csvData);
               // console.log('ispartialValidation ---->>', ispartialValidation);
               // if(tempResult.shippingid != null && tempResult.debitfromtype != null && tempResult.userid != null && tempResult.debitamount != null && tempResult.remainingamount != null && tempResult.ispartialdebit != null ) {
               //   // console.log('tempResult --->>', tempResult);
               //    csvData.push(tempResult);
               // }
           },
           complete: function(){
             // console.log('holdErrorsTest ==>>', holdErrors.length);
             // console.log('csvData.length ==>>', csvData.length);
             // console.log('this.UploadConfigDetails123 --->>', this.UploadConfigDetails.pageCuttoff);
             let pagelimit = this.UploadConfigDetails.pageCuttoff && this.UploadConfigDetails.pageCuttoff != '' ? this.UploadConfigDetails.pageCuttoff : '100'
             let Batchlimit = this.UploadConfigDetails.batchCuttoff && this.UploadConfigDetails.batchCuttoff != '' ? this.UploadConfigDetails.batchCuttoff : '5000'
             // console.log('pagelimit ----->', pagelimit);
             // console.log('Batchlimit ----->', Batchlimit);
             // console.log('validheader ----->', validheader);
             if(validheader == 0){
               this.isLoading = false;
               this.filedata = [];
               this.filename = null;
               this.file = ''
               return this.$alertify.error('header mismatch issue, Please make ensure header should be in uppercase.!', "", "error");

             } else if(holdErrors.length > 0){
               this.errorList = holdErrors
               this.isLoading = false;
               this.filedata = [];
               this.filename = null;
               this.file = ''
               return this.$alertify.error('Invalid data in the file.', "", "error");

             } else if(csvData.length<1){
               this.isLoading = false;
               this.filedata = [];
               this.filename = null;
               this.file = ''
               return this.$alertify.error('Uploaded file is blank. At least one record set is required.', "", "error");
             } else if (csvData.length > pagelimit) {
               this.errorList = holdErrors
               this.isLoading = false;
               this.filedata = [];
               this.filename = null;
               this.file = ''
               return this.$alertify.error(`Allowed only ${pagelimit} shipments in one go, please upload file accordingly.`, "", "error");
             }
             else{
               this.filedata = csvData;
               this.totalrecords = csvData.length;
               this.chunkArray(this.filedata, Batchlimit); //pass batch cuttoff
             }
           }.bind(this)
       });
     },
     async chunkArray(myArray, chunk_size){
           try {
           console.log("Start Time", Date() );

           var index = 0;
           var arrayLength = myArray.length;
           let tempArr = [];
           let promiseArray = []
           this.UpdateApprovalKey = [];
           this.PromiseChainResult = [];

           let chain = Promise.resolve();
           let self = this

           for(index = 0; index < arrayLength; index += chunk_size) {
             let myChunk = myArray.slice(index, index+chunk_size);
             // console.log('myChunk ----->>>>', myChunk);
             chain = chain.then(() => self.uploadHRApproval(myChunk, index));
           }
           chain.then((result) => {
             // console.log('Result  Test---->>', result);
             if(result) {
               let tempTotalCount = 0;
               let tempUploadedTotalCount = 0;
               this.PromiseChainResult.forEach((value,idx) => {
                 tempTotalCount = parseFloat(tempTotalCount) + parseFloat(value.TotalCount)
                 tempUploadedTotalCount = parseFloat(tempUploadedTotalCount) + parseFloat(value.insertedCount)
               })
               this.uploadResult = [];
               this.uploadResult.push({"totalCount": tempTotalCount, "uploadeCount": tempUploadedTotalCount});
               // this.$alertify.success("File data loaded Successfully");
               let reqObjectProcess = {
                 batchkey: this.UpdateApprovalKey,
                 statusfor: this.approvalfor,
                 lastmodifiedby: this.localusermailid
               }
               console.log("End Time", Date());
               this.triggerPopUpDialogForConfirmation(this.uploadResult, reqObjectProcess)
             } else {
                this.isLoading = false;
                return false;
              }
              this.isLoading = false;
           })
           .catch((err) => {
             console.log('chain error', err);
           })
         }catch (err){
           console.log(err);
         }
      },
      async triggerPopUpDialogForConfirmation(getResult, reqObjectProcess) {

        let htmltablecontent = '<table border="2" cellpadding="10" cellspacing="0"> <th>Total Count</th> <th>Uploaded Count</th>';
        let resultcount = getResult.length
        for(let j=0; j< resultcount; j++) {

          htmltablecontent +=`
            <tr>
              <td> ${getResult[j].totalCount} </td>
              <td> ${getResult[j].uploadeCount } </td>
            </tr>`
        }
        htmltablecontent += `</table>`;
        // console.log('htmltablecontent --->>', htmltablecontent);
        let message = {
            title: 'Alert',
            body: `<p>Uploaded summary.! <br/> Do you want to proceed for update approval? </p><br/>
            ${htmltablecontent}
            <br>
            `,
          };

          let res = await this.$dialog.confirm(message, {
            html: true,
            animation: 'bounce',
            backdropClose: false,
            okText: 'Yes',
            cancelText: 'No',
            reverse: true
          })
          .then(dialog => {
            console.log('success', reqObjectProcess);
            this.$alertify.success("File uploaded successfully, output summary will be sent over email.");
            this.processDumpData(reqObjectProcess)
          })
          .catch((e) => {
            //add logic for delete mechanism.
            console.log('popup catch',e);
          })
      },
      processDumpData(reqObjectProcess) {

        axios({
          method: 'POST',
          url: apiUrl.api_url + 'lostshipmentinfo/approval/processuploaded/dump',
          data: reqObjectProcess
        }).then(async approveHRresult => {
          console.log('approveHRresult -->>', approveHRresult);
          this.clear()
        }, error => {
          this.ConfirmLoader = false
        });
      },
      // validteShippingID(pushErrors, obj,sheetid){
      //   return new Promise((resolve, reject) => {
      //     try {
      //       if(obj.shippingid == null) {
      //         pushErrors.push({'lineNumber': sheetid, 'message': 'Shipping id should not be empty.!'})
      //         resolve(pushErrors)
      //       } else {
      //         resolve(pushErrors)
      //       }
      //     } catch(e){
      //       console.log('catch errror --->>', e);
      //     }
      //   })
      // },
      // validteDebitFromType(pushErrors, obj,sheetid){
      //   return new Promise((resolve, reject) => {
      //     if(obj.debitfromtype == null) {
      //       pushErrors.push({'lineNumber': sheetid, 'message': 'Debit from type column should not be empty.!'})
      //       resolve(false)
      //     } else {
      //       resolve(true)
      //     }
      //   })
      // },
      // validteUserid(pushErrors, obj,sheetid){
      //   return new Promise((resolve, reject) => {
      //     let numberRegex = /^[0-9]+$/;
      //
      //     if(obj.userid == null) {
      //       pushErrors.push({'lineNumber': sheetid, 'message': 'Debit User column should not be empty.!'})
      //       resolve(false)
      //     } else if(numberRegex.test(parseFloat(parseFloat(obj.userid))) == false) {
      //       pushErrors.push({'lineNumber': sheetid, 'message': 'Debit user id must be be number.!'})
      //       resolve(false)
      //     } else {
      //       resolve(true)
      //     }
      //   })
      // },
      // validteDebitAmount(pushErrors, obj,sheetid) {
      //   // return new Promise((resolve, reject) => {
      //     let numberDebitRegex = /^\d*\.?\d*$/;
      //     if(obj.debitamount == null) {
      //       pushErrors.push({'lineNumber': sheetid, 'message': 'Debit amount should not be empty.!'})
      //       // resolve(false)
      //       return false
      //     } else if(obj.debitamount == 0) {
      //       pushErrors.push({'lineNumber': sheetid, 'message': 'Debit amount should be greater than zero.!'})
      //       // resolve(false)
      //     } else if(numberRegex.test(parseFloat(obj.debitamount)) == false) {
      //       pushErrors.push({'lineNumber': sheetid, 'message': 'Debit amount should be number.!'})
      //       // resolve(false)
      //       return false
      //     } else {
      //       return true
      //       // resolve(true)
      //     }
      //   // })
      // },
      // validteRemainingAmount(pushErrors, obj,sheetid) {
      //   return new Promise((resolve, reject) => {
      //     let numberRegex = /^\d*\.?\d*$/;
      //     if(obj.remainingamount == null) {
      //       pushErrors.push({'lineNumber': sheetid, 'message': 'Debit amount should not be empty.!'})
      //       resolve(false)
      //     } else if(numberRegex.test(parseFloat(obj.remainingamount)) == false) {
      //       pushErrors.push({'lineNumber': sheetid, 'message': 'Debit amount should be number.!'})
      //       resolve(false)
      //     } else {
      //       resolve(true)
      //     }
      //   })
      // },
      // validteIspartial(pushErrors, obj,sheetid) {
      //   return new Promise((resolve, reject) => {
      //     if(obj.ispartialdebit == null) {
      //       pushErrors.push({'lineNumber': sheetid, 'message': 'Partial debit column should not be empty.!'})
      //       resolve(false)
      //     } else if (!['0','1'].includes(obj.ispartialdebit)) {
      //       pushErrors.push({'lineNumber': sheetid, 'message': 'Partial column allows only input as 0 or 1.!'})
      //       resolve(false)
      //     } else {
      //       resolve(true)
      //     }
      //   })
      // },
      uploadHRApproval(myChunk, index) {
        return new Promise((resolve, reject) => {
          try {
            let batchId =`F${(Math.random() + 1).toString(36).substring(9)}`;
            // console.log("random", batchId);
            let newChunkArray = myChunk.map(chunk => Object.assign(chunk, {approvalkey: batchId}))
            this.UpdateApprovalKey.push(batchId)
            let approveObj = {
              approvalShipments: newChunkArray,
              approvalKey: batchId,
              approvalFor: this.approvalfor,
              CreatedBy: this.localusermailid
            }
            axios({
              method: 'POST',
              url: apiUrl.api_url + 'lostshipmentinfo/approval/upload/dump',
              data: approveObj
            }).then(async approveHRresult => {
              // console.log('approveHRresult -->>', approveHRresult);
              this.batchkeyArray.push(batchId)
              if (approveHRresult.data.code == 200) {
                this.PromiseChainResult.push(approveHRresult.data.data)
                resolve(true)
              }else if (approveHRresult.data.code == 202){
                this.$alertify.error('Invalid data in csv file, '+ approveHRresult.data.message);
                resolve(false)
              } else {
                this.$alertify.error(approveHRresult.data.message);
                resolve(true)
              }

            }, error => {
              resolve(false)
              console.error(1,error)
              this.ConfirmLoader = false
            });
          } catch(e) {
            resolve(e)
          }
        })
      },
      getconfigFlags() {
        return new Promise((resolve,reject) => {
          axios({
            method: 'POST',
            url: apiUrl.api_url + 'rediscluster/get',
            data: { "key": "uploadConfigskeysFlag" }
          }).then(async getconfigset => {
            console.log('getconfigset -->', getconfigset);
            resolve(getconfigset.data.message)
          })
        })
      },
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {

      }).catch((e) => {
        console.log('log errors', e);
      });
    },
    clear(){

      this.UpdateApprovalKey = [];
      this.PromiseChainResult = [];
      this.isLoading = false;
      this.filedata = [];
      this.filename = null;
      this.file = ''
      this.uploadApprovecsv = ''
      this.approvalfor = 0
      this.errorList = []
      const input = this.$refs.files;
      input.type = 'text';
      input.type = 'file';

      console.log('file cleared.!');
      this.$validator.reset();
      this.errors.clear();
    },
    downloadsampleformat() {
      let sampleData = [
        {
          "SHIPPINGID": "123456789876543",
          "DEBITFROMTYPE": "servicecenter",
          "DEBITID": "12345",
        },
      ];
      let csvContent = "data:text/csv;charset=utf-8,";
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      let filename = "uploadSamleFormat" + today + ".csv";
      csvContent += [
        Object.keys(sampleData[0]).join(";"),
        ...sampleData.map(item => Object.values(item).join(";"))
      ]
      .join("\n")
      .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      link.click();
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/components/LOST/lostUploadApproval/lostUploadApproval.component.js